import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from fastapi.responses import JSONResponse
from posthog import Posthog

posthog = Posthog('<ph_project_api_key>', host='<ph_client_api_host>')

@app.exception_handler(Exception)
async def http_exception_handler(request, exc):
    posthog.capture_exception(exc)
    return JSONResponse(status_code=500, content={'message': str(exc)})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      